import { render, staticRenderFns } from "./Painel.vue?vue&type=template&id=3f57c263&scoped=true&"
import script from "./Painel.vue?vue&type=script&lang=js&"
export * from "./Painel.vue?vue&type=script&lang=js&"
import style0 from "./Painel.vue?vue&type=style&index=0&id=3f57c263&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f57c263",
  null
  
)

export default component.exports